<div class="tab tab--bottom">
  <button appTooltip="Risk Info Table" tooltipPosition="top" (click)="openInfoTable()">
    <span><i class="fa fa-lg fa-table"></i></span>
  </button>
</div>
